import { render, staticRenderFns } from "./TableProducts.vue?vue&type=template&id=61641095"
import script from "./TableProducts.vue?vue&type=script&lang=js"
export * from "./TableProducts.vue?vue&type=script&lang=js"
import style0 from "./TableProducts.vue?vue&type=style&index=0&id=61641095&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports